import { render, staticRenderFns } from "./DeleteIndexModal.vue?vue&type=template&id=a96292ae&"
import script from "./DeleteIndexModal.vue?vue&type=script&lang=js&"
export * from "./DeleteIndexModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports